import { qrySelfChainsApi } from "@/libs/api.js";
import shareButton from "@/components/ylsq/shareButton.vue";
import countDown from "@/components/ylsq/countDown.vue";
import { getCookie } from "@/libs/common";
export default {
  name: "copy",
  components: {
    shareButton,
    countDown,
  },
  data() {
    return {
      isShowBottom: false,
      myQuery: {
        orgId: "",
        pageIndex: 1,
        pageSize: 10,
        clientCallType: "H5",
      },
      myList: [],
      myListStatus: 0, // 列表状态 0-初始 1-有数据 2-无数据
      myListFinished: false,
      myListIsLoad: false,
      myListLoading: false,
      myListFinishedText: "加载中...",
      myListSurplus: 0, // 剩余个数
      orgId: "",
    };
  },
  mounted() {
    let _this = this;
    // 获取orgId
    if (_this.$browser().ylxdsq) {
      console.log("lowestOrgCode===", getCookie("lowestOrgCode"));
      _this.myQuery.orgId = getCookie("lowestOrgCode") || 58093;
      _this.getMyList();
    } else {
      _this.myQuery.orgId = "58093";
      _this.getMyList();
    }
  },
  computed: {
    computingTime() {
      return function(date) {
        let n = this.$moment().diff(date, "hour");
        if (n < 24) {
          if (n == 0 || n < 0) {
            return `1小时前`;
          } else {
            return `${n}小时前`;
          }
        } else if (n >= 24 && n < 48) {
          return `昨天`;
        } else if (n >= 48 && n < 72) {
          return `前天`;
        } else {
          return this.$moment(date).format("YYYY/MM/DD");
        }
      };
    },
  },
  methods: {
    // 创建接龙
    handleCreateGroup() {
      console.log("创建接龙");
    },
    handleTogglePop(res) {
      this.isShowBottom = res;
    },
    // 我发布的
    getMyList() {
      console.log("myQuery====", this.myQuery);
      qrySelfChainsApi(this.myQuery).then((res) => {
        if (res.returnCode == "0000" && res.data.result.length > 0) {
          this.myList = this.myList.concat(res.data.result);
          let myListTotalPages = Math.ceil(res.data.totalRecords / this.myQuery.pageSize);
          if (this.myQuery.pageIndex == myListTotalPages) {
            this.myListFinished = true;
            this.myListFinishedText = "我已到达底部, 暂无其他数据啦~~";
          } else {
            this.myListFinished = false;
            this.myQuery.pageIndex++;
          }
          this.myList.length > 0 ? (this.myListStatus = 1) : (this.myListStatus = 2);
          // 剩余条数
          this.myListSurplus = res.data.totalRecords - this.myList.length;
          this.myList.forEach((item) => {
            // 活动描述
            if (item.activityDesc) {
              item.activityDescList = JSON.parse(item.activityDesc);
            } else {
              item.activityDescList = [];
            }
            // 活动图片
            if (item.imgUrl) {
              item.imgList = item.imgUrl.split(",");
              if (item.imgList.length > 1) {
                item.showMore = true;
              }
            } else {
              item.imgList = [];
              item.showMore = false;
            }
            item.lastTime = this.$moment(item.endTime)
              .diff(this.$moment())
              .toString();
            item.activityStartTime = this.$moment(item.startTime).format("YYYY/MM/DD");
            item.activityEndTime = this.$moment(item.endTime).format("YYYY/MM/DD");
            item.activityStateText = {
              0: "未发布",
              1: "未开始",
              2: "接龙中",
              3: "已结束",
            }[item.activityState];
            let currentDate = this.$moment(Date.now()).format("YYYYMMDDHHmmss"), // 当前时间
              endDate = this.$moment(item.endTime).format("YYYYMMDDHHmmss"); // 活动结束时间
            currentDate > endDate ? (item.isOver = true) : (item.isOver = false);
          });
        } else {
          this.myListStatus = 2;
          this.myListFinished = true;
        }
      });
    },
    // 更新接龙状态
    getStateCanOver(index) {
      this.myList[index].activityState = 3;
      this.myList[index].activityStateText = "已结束";
    },
    // 复制团
    handleCopy(id) {
      let obj = {
        activityId: id,
        logistics: "2",
      };
      obj = JSON.stringify(obj);
      console.log("obj", obj);
      window.dsBridge.call("copyGroup", obj);
    },
  },
};
